import loadable from "@loadable/component";

export const ContentSection = loadable(() => import("./ContentSection"), {
  resolveComponent: mod => mod.ContentSection,
});

export type {
  ContentSectionProps,
  ContentSectionName,
  ContentSectionComponentProps,
} from "./ContentSection";
